exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-sm[data-v-266733cb]{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}", ""]);

// exports
